const defaultView = {
  key: 'default',
  type: 'tenant',
  properties: [],
  customProperties: [],
  filters: [],
  sort: [],
};

const createDefaultView = (intl, options = {}) => {
  const name = intl.formatMessage({
    id: 'defaultView.name',
    defaultMessage: 'Default',
    description: 'Default view name',
  });

  const description = intl.formatMessage({
    id: 'defaultView.description',
    defaultMessage: 'Default view',
    description: 'Default view description',
  });

  return {
    ...defaultView,
    name,
    description,
    label: name,
    ...options,
  };
};

export default createDefaultView;
